import message from 'antd/es/message';
import 'antd/es/message/style/css';

export default message;
